import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTranslationRed = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_14195_8874)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M4.16602 6.66602L9.16602 11.666",
				stroke: "#DC2626",
				strokeWidth: 1.66667,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.33398 11.666L8.33398 6.66602L10.0007 4.16602",
				stroke: "#DC2626",
				strokeWidth: 1.66667,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.66602 4.16602H11.666",
				stroke: "#DC2626",
				strokeWidth: 1.66667,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.83398 1.66602H6.66732",
				stroke: "#DC2626",
				strokeWidth: 1.66667,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.3333 18.3333L14.1667 10L10 18.3333",
				stroke: "#DC2626",
				strokeWidth: 1.66667,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.666 15H16.666",
				stroke: "#DC2626",
				strokeWidth: 1.66667,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_14195_8874",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgTranslationRed);
export default ForwardRef;
